<template>
  <div style="overflow-y:auto;">
    <div class="w_Header">
      <div class="w_HeaderMain clear">
        <h3 class="yr_logoName">电子保函系统</h3>
      </div>
    </div>
    <div class="wBh_container">
      <div class="wBh_Charge clear">
        <div class="wbh_orderlayer">
          <div class="wbh_orderlayerMain">
            <img src="../../assets/applyDui.png" />
            <h5 class="WaitingText">恭喜您，申请成功！</h5>
            <h6 class="WaitingTime">
              <p>您的电子保函申请已提交成功，请等待农行客服联系您</p>
            </h6>
            <div class="jrfwxt" @click="back">关闭当前页面</div>
          </div>
        </div>
      </div>
    </div>
    <div class="w_Footer">
      <ul>
        <li>Copyright ® 公航旅电子交易中心平台 All right reserved</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryUrl: process.env.VUE_APP_QueryUrl
    };
  },
  methods:{
    back(){
      this.$router.push("/")
    }
  }
};
</script>

<style scoped="scoped" lang="less">
* {
  margin: 0px;
  padding: 0px;
}
body {
  font-family: Microsoft YaHei;
  font-size: 14px;
  color: #989898;
}
/**清除浮动**/
.clear:after {
  display: block;
  clear: both;
  content: "";
}
.clear {
  zoom: 1;
}

.w_Header {
  height: 70px;
  width: 100%;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 6px 10px 0px rgba(173, 174, 174, 0.16);
  position: relative;
  z-index: 1;
}
.w_HeaderMain {
  width: 1200px;
  margin: auto;
  height: 70px;
  overflow: hidden;
}
.yr_logo {
  float: left;
  display: block;
  border: none;
  width: 130px;
  margin-top: 15px;
}
h3.yr_logoName {
  float: left;
  font-size: 22px;
  color: #666;
  font-weight: 500;
  padding-left: 30px;
  // border-left: 1px solid #edeff0;
  // margin-left: 30px;
  height: 70px;
  line-height: 70px;
}
.wBh_container {
  background: #f6f8f9;
  position: relative;
  overflow: hidden;
}

.w_Footer {
  width: 100%;
  padding: 30px 0px;
  background: #333333;
}
.w_Footer ul li {
  width: 100%;
  text-align: center;
  color: #999;
  margin-top: 6px;
}
.w_Footer ul li:first-child {
  margin-top: 0px;
}

/*5月8日 提交成功页面       开始*/

.wbh_orderlayer {
  background-color: #fff;
}
.wbh_orderlayerMain {
  width: 480px;
  margin: auto;
  overflow: hidden;
  text-align: center;
}
.wbh_orderlayerMain img {
  display: block;
  border: none;
  width: 90px;
  margin: 126px auto 24px auto;
}

h5.WaitingText {
  font-weight: normal;
  font-size: 20px;
  width: 100%;
  text-align: center;
  color: #3CDD74;
  padding-bottom: 20px;
  height: 22px;
  line-height: 22px;
  font-weight: bold;
}
h6.WaitingTime {
  padding: 0px 40px;
  font-weight: normal;
  font-size: 12px;
  color: #666666;
  line-height: 14px;
  padding-bottom: 22px;
}
h6.WaitingTime p {
  padding-bottom: 5px;
}
.jrfwxt {
  text-decoration: none;
  display: block;
  // width: 170px;
  width: 200px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  background: #3CDD74;
  border-radius: 4px;
  margin: 46px auto 0px auto;
}
.jrfwxt:hover {
  opacity: 0.85;
}

.wBh_Charge {
  width: 1200px;
  padding: 36px 0px;
  margin: auto;
  box-sizing: border-box;
}
</style>
